import React from 'react'
import { ProductCard } from "../../../ui/productCard/ProductCard"
export default function Item({ product }) {


    return (
        <li key={product.id}><ProductCard product={product} /> </li>
    )
}
